import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../../../componentLibrary/TopicButton";
import ConfirmationBox from "../../../../componentLibrary/ConfirmationBox";

export default function CustomLinkComponent({
  button_text,
  url,
  url_type,
  icon_url,
  icon_alt,
  className,
  disabled = false,
  savePageInput,
  lesson,
}: {
  button_text: string;
  url: string;
  url_type: "external" | "local";
  icon_url?: string;
  icon_alt?: string;
  className?: string;
  disabled?: boolean;
  savePageInput?: () => void;
  lesson?: { title: string };
}) {
  const navigate = useNavigate();
  const [openConfirmation, setOpenConfirmation] = useState(false);

  const handleClick = () => {
    if (url_type === "local") {
      navigate(url);
    } else {
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  const getShortUrl = (url: string, url_type: "external" | "local") => {
    if (url_type === "local") {
      return `the ${url.replace(/^\//, "")} page`;
    }
    try {
      const urlObj = new URL(url);
      return urlObj.hostname;
    } catch {
      return url;
    }
  };

  const confirmationBoxMessage = (
    <p>
      Your progress {lesson ? "in" : ""} {lesson ? <b>{lesson.title}</b> : ""}{" "}
      will be saved.
    </p>
  );

  const handleConfirm = () => {
    if (savePageInput) {
      savePageInput();
    }
    handleClick();
    setOpenConfirmation(false);
  };

  return (
    <div className={`shadow-lg ${className ? className : ""}`}>
      <CustomButton
        className="w-full"
        color={"#FF0000"}
        icon={
          icon_url ? (
            <img className="w-12 h-12" src={icon_url} alt={icon_alt || ""} />
          ) : undefined
        }
        onClick={() => setOpenConfirmation(true)}
        text={button_text}
        disabled={disabled}
      />
      <ConfirmationBox
        isOpen={openConfirmation}
        message={confirmationBoxMessage}
        title={`Do you want to go to ${getShortUrl(url, url_type)}?`}
        onConfirm={handleConfirm}
        onCancel={() => setOpenConfirmation(false)}
        confirmText="Open"
        cancelText="Stay Here"
      />
    </div>
  );
}
